import { useEffect, useState } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _EmployeeContract } from '../../../../../core/services/dataBean/EntityCatalog';
import { toast } from 'react-toastify';
import { Modal } from '../../../../theme/Component/Modal';
import { AccountEditor } from '../../../../editor/AccountEditor';
import { BasicButton } from '../../../../theme/Component/BasicButton';
import { BasicTable } from '../../../../theme/Component/BasicTable';


interface Props {
    value?: any;
    renderValue?: string;
    onChange: any;
    label?: string;
    disabled?: boolean
    filterType?: number;
}
export const SelectContractEditor = ({ value, onChange, label, filterType, renderValue, disabled }: Props) => {

    const { instance, setBean, bean, lista, setLista } = useDataBean(_EmployeeContract)

    const [modal, setModal] = useState<any>({ name: 'Contratos Laborales', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [valor, setValor] = useState('');
    const [idAccount, setIDAccount] = useState<number>(null)

    useEffect(() => {
        if (renderValue) {
            setValor(renderValue)
        }
    }, [renderValue])



    const getLista = () => {
        if (idAccount) {

            instance.getEmployeeContract(idAccount).then(
                (resp) => {
                    setLista(resp)
                }
            ).catch(err => { toast.error(err) })
        } else {
            toast.error("Debe seleccionar un usuario valido")
        }
    }

    const returnValue = () => {
        if (bean.IDContract) {
            setValor(`${bean.IDContract ?? ""} - ${bean.EmploymentTypeName} - ${bean.EntailmentName}`)
            setModal({ ...modal, "view": false });
            onChange(bean);
        } else {
            toast.error("Contrato no valido")
        }
    }

    const head = [
        { title: 'ID', property: 'IDContract', visible: true },
        { title: 'Periodo Laboral', property: 'Period', visible: true },
        { title: 'Nivel Jerarquico', property: 'EntailmentName', visible: true },
        { title: 'Grupo Laboral', property: 'EmploymentTypeName', visible: true },
    ]

    return (
        <>
            <label>{"Seleccione un Contrato Laboral"}</label>
            <div className={`form-control text-wrap ${disabled ? 'bg-light text-muted' : 'cursor-pointer'}`}
                style={{ minHeight: '35px' }}
                onClick={() => {
                    if (!disabled) {
                        setModal({ ...modal, view: true });
                    }
                }}
            >
                {valor ? valor : <span>Seleccionar...</span>}
            </div>

            <Modal onSubmitLabel='Seleccionar' modal={modal} updateModal={setModal} eventModal={returnValue}>
                <div className="row">
                    <div className="col-md-10">
                        <AccountEditor idAccount={idAccount} label='Empleado' onChange={(e) => { setIDAccount(e.IDAccount) }} />
                    </div>
                    <div className="col-md-2 mt-4">
                        <BasicButton eventClick={getLista} icon='ri-search-line' children={"Buscar"} />
                    </div>
                    <div className="col-md-12">
                        <BasicTable body={lista} head={head } rowSet={setBean} />
                    </div>
                </div>
            </Modal>

        </>
    )
}